/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Bookmark Icon component.
 */
export const MapBookmarkIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M12.174 2a.5.5 0 01.676.001l7.598 6.984a.5.5 0 01.082.64l-7.598 11.727a.5.5 0 01-.84 0L4.485 9.59a.5.5 0 01.082-.641L12.174 2z'
        stroke={iconColor}
        strokeWidth={1.5}
        clipRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round' />
      <circle stroke={iconColor}
        cx={12.505}
        cy={10.184}
        r={2.062}
        strokeWidth={1.5} />
    </svg>
  );
};
